export default __webpack_public_path__ + "static/media/mail_active.7a9bc52d.png";